export const getLastFilledPageNumberIfPageIsEmpty = (filteredData, pagination) => {
  // if no devices are shown
  if (filteredData.length < (pagination.pageNumber - 1) * pagination.pageSize) {
    // we need Math.trunc as that case handles 0 items as well as compared to Math.floor
    const lastPage = Math.trunc((filteredData.length - 1) / pagination.pageSize)
    return lastPage + 1
  }
  return null
}
